import { message, notification } from "antd";
import { WIZARD } from '../../../utils/Constants'

const Validation = (wizard) => {
  let errors = [];
  if (wizard.page === 1) {
    if (wizard.first_name === '') errors.push('First name missing.');
    if (wizard.last_name === '') errors.push('Last name missing.');
    if (wizard.phone === '') errors.push('Phone missing.');
  }

  if (errors.length === 0) {
    return { success: true }
  } else {
    return { success: false, errors }
  }
}


const wizardError = (err, name) => {
  message.destroy();
  if (name !== 'gotoStepIndex') {
    message.error(err)
  }

  // message.error(err);
  return false;
}

const isEmpty = (str) => {
  return str === "" || str === null;
}


const setStatusIndex = (steperror, current, updateField, status = "") => {
  steperror = { ...steperror, currentIndex: { ...steperror.currentIndex, [current]: status } };
  updateField('steperror', steperror)
}


export const validationCheck = (wizard = {}, updateField, name) => {

  let steperror = { ...wizard.error };
  let stepIndex = wizard.stepIndex;

  let current = 0;
  if (stepIndex >= 1 && stepIndex < 2) current = 1;
  if (stepIndex >= 2 && stepIndex < 4) current = 2;
  if (stepIndex >= 4 && stepIndex < 9) current = 3;
  if (stepIndex >= 9 && stepIndex < 11) current = 4;
  if (stepIndex >= 11 && stepIndex < 13) current = 5;
  if (stepIndex === 13) current = 6;
  if (stepIndex >= 14 && stepIndex < 16) current = 7;


  if (name === 'filingStatus') {
    return setStatusIndex(steperror, current, updateField, 'filing')
  }

  if (stepIndex === 1) {
    let temp = ['first_name', 'last_name', 'phone']
    // wizard.carrier != WIZARD.CARRIER.COUNTRY_FINANCIAL ? temp.push('dob_mm', 'dob_yyyy', 'dob_dd') : null
    let isnotempty = temp.map((e, i) => {
      if (isEmpty(wizard[e])) {
        steperror = { ...steperror, [e]: true };
        return false
      }
      return true
    })
    if (isnotempty.some(e => e === false)) {
      setStatusIndex(steperror, current, updateField, 'error')
      return wizardError("Please fill all required fields.", name);
    } else {
      setStatusIndex(steperror, current, updateField, 'filled')
    }

  }



  if (stepIndex >= 2 && stepIndex < 4) {
    if (
      isEmpty(wizard.secondary_vehicles_toggle)
    ) {
      steperror = { ...steperror, secondary_vehicles_toggle: true }
      setStatusIndex(steperror, current, updateField, 'error')
      return wizardError("Please fill recreational vehicles fields.", name);
    } else {
      if (wizard.secondary_vehicles_toggle === "1") {
        let secondary_vehicles = [];
        if (
          wizard.secondary_vehicles !== null &&
          wizard.secondary_vehicles !== ""
        ) {
          secondary_vehicles = JSON.parse(wizard.secondary_vehicles);
        }
        if (secondary_vehicles.length === 0) {
          // setStatusIndex(steperror, current, updateField, 'error')
          steperror = { ...steperror, secondary_vehicles: true }
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please select secondary vehicles.", name);
        }
        if (wizard.secondary_vehicles_value === "" || wizard.secondary_vehicles_value === null) {
          // setStatusIndex(steperror, current, updateField, 'error')
          steperror = { ...steperror, secondary_vehicles_value: true }
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Secondary vehicles value is required.", name);
        }
        if (
          wizard.secondary_vehicles !== null &&
          wizard.secondary_vehicles !== "" && stepIndex === 3
        ) {
          setStatusIndex(steperror, current, updateField, 'filled')
        }
      } else {
        setStatusIndex(steperror, current, updateField, 'filled')
      }
    }
  }

  if (stepIndex >= 4 && stepIndex < 9) {


    if (stepIndex === 4) {
      if (wizard.home_toggle === "" || wizard.home_toggle === null) {
        steperror = { ...steperror, home_toggle: true }
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Please fill all required fields.", name);
      }
      if (wizard.home_toggle === "1") {
        if (wizard.home_market_value === "" || wizard.home_market_value === null) {
          steperror = { ...steperror, home_market_value: true }
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Market value of the home is required.", name);
        }
      }
    }

    if (stepIndex === 5) {
      if (wizard.home_mortgage) {
        if (wizard.home_mortgage_protection_toggle === "" || wizard.home_mortgage_protection_toggle === null || wizard.life_insurance_toggle_1 === null) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Life insurance value is required.", name);
        }
      }

      if (wizard.home_mortgage_protection_toggle === "1" && wizard.insurance_set === "primary_home") {
        let home_mortgage_protection_policy = [];
        if (wizard.home_mortgage_protection_policy !== "" && wizard.home_mortgage_protection_policy !== null) {
          home_mortgage_protection_policy = JSON.parse(
            wizard.home_mortgage_protection_policy
          );
        }

        if (home_mortgage_protection_policy.length === 0) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please select the life insurance.", name);
        }

        if (wizard.home_mortgage_protection_benefit === "" || wizard.home_mortgage_protection_benefit === null) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Benefit value of life insurance is required.", name);
        }
      }
    }

    if (stepIndex === 6) {
      if (wizard.secondary_home_toggle === "" || wizard.secondary_home_toggle === null) {
        steperror = { ...steperror, secondary_home_toggle: true }
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Please fill all required fields.", name);
      }
      let secondary_home_type = [];
      if (
        wizard.secondary_home_type !== null &&
        wizard.secondary_home_type !== ""
      ) {
        secondary_home_type = JSON.parse(wizard.secondary_home_type);
      }
      if (wizard.secondary_home_toggle === "1") {
        if (secondary_home_type.length === 0) {
          steperror = { ...steperror, secondary_home_type: true }
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please select all owned secondary properties.", name)
        }
        if (wizard.secondary_home_market_value === "" || wizard.secondary_home_market_value === null) {
          steperror = { ...steperror, secondary_home_market_value: true }
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Market value of other homes is required.", name);
        }
      }
    }

    if (stepIndex === 7) {
      if (wizard.secondary_home_mortgage_toggle === "1") {
        if (wizard.secondary_home_mortgage === "" || wizard.secondary_home_mortgage === null) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please fill the secondary home mortgage value.", name);
        }
      }

      if (wizard.secondary_home_mortgage)
        if (wizard.home_mortgage_protection_toggle === "" || wizard.home_mortgage_protection_toggle === null || wizard.life_insurance_toggle_2 === null) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Life insurance value is required.", name);
        }

      if (wizard.home_mortgage_protection_toggle === "1" && wizard.insurance_set === "secondary_home") {
        let home_mortgage_protection_policy = [];
        if (wizard.home_mortgage_protection_policy !== "" && wizard.home_mortgage_protection_policy !== null) {
          home_mortgage_protection_policy = JSON.parse(
            wizard.home_mortgage_protection_policy
          );
        }

        if (home_mortgage_protection_policy.length === 0) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please select the life insurance.", name);
        }

        if (wizard.home_mortgage_protection_benefit === "" || wizard.home_mortgage_protection_benefit === null) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Benefit value of life insurance is required.", name);
        }
      }
    }

    if (stepIndex === 8) {
      if ((wizard.home_toggle === "" || wizard.home_toggle === null) && (wizard.secondary_home_toggle === "" || wizard.secondary_home_toggle === null)) {
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Please fill all previous fields.", name);
      }
      else if (wizard.personal_property_toggle === 1) {
        let personal_property_type = [];
        if (wizard.personal_property_type !== "" && wizard.personal_property_type !== null) {
          personal_property_type = JSON.parse(wizard.personal_property_type)
        }

        if (personal_property_type.length === 0) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please select the personal property.", name);
        }

        if (wizard.personal_property_value === "" || wizard.personal_property_value === null) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Personal property's value is required.", name);
        }

        if (personal_property_type.length > 0 && wizard.personal_property_value !== "" || wizard.personal_property_value !== null)
          setStatusIndex(steperror, current, updateField, 'filled')
      }
      else
        setStatusIndex(steperror, current, updateField, 'filled')
    }

  }

  if (stepIndex >= 9 && stepIndex < 11) {
    if (stepIndex === 9) {
      if (wizard.business_owner_toggle === "" || wizard.business_owner_toggle === null) {
        steperror = { ...steperror, business_owner_toggle: true }
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Please fill all required fields.", name);
      }

      if (wizard.business_owner_toggle === "1") {
        let temp = ['business_name', 'employees_count', 'business_type']
        if (wizard.business_type === "Other" && isEmpty(wizard['business_type_other'])) {
          temp.push('business_type_other');
        }
        
        let isnotempty = temp.map((e, i) => {
          if (isEmpty(wizard[e])) {
            steperror = { ...steperror, [e]: true };
            return false
          }
          return true
        })
        if (isnotempty.some(e => e === false)) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please fill all required fields.", name);
        }

        // if (wizard.business_name === "" || wizard.business_name === null) {
        //   steperror = { ...steperror, business_name: true }
        //   setStatusIndex(steperror, current, updateField, 'error')
        //   return wizardError("Business name is required.", name);
        // }

        // if (wizard.employees_count === "" || wizard.employees_count === null) {
        //   setStatusIndex(steperror, current, updateField, 'error')
        //   return wizardError("Employee details are required.", name);
        // }

        // if (wizard.business_type === "" || wizard.business_type === null) {
        //   setStatusIndex(steperror, current, updateField, 'error')
        //   return wizardError("Please select business type.", name);
        // }

        // if (wizard.business_type === "Other" && (wizard.business_type_other === "" || wizard.business_type_other === null)) {
        //   steperror = { ...steperror, business_type: true }
        //   setStatusIndex(steperror, current, updateField, 'error')
        //   return wizardError("Other busineess type is required.", name);
        // }
      }
    }

    if (stepIndex === 10) {
      if (wizard.employed_toggle && wizard.employed_toggle === "1") {
        let temp = ['employer_name', 'employer_years']
        let isnotempty = temp.map((e, i) => {
          if (isEmpty(wizard[e])) {
            steperror = { ...steperror, [e]: true };
            return false
          }
          return true
        })
        if (isnotempty.some(e => e === false)) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please fill all required fields.", name);
        }
        // if (wizard.employer_name === "" || wizard.employer_name === null) {
        //   steperror = { ...steperror, employer_name: true }
        //   setStatusIndex(steperror, current, updateField, 'error')
        //   return wizardError("Employer name is required.", name);
        // }

        // if (wizard.employer_years === "" || wizard.employer_years === null) {
        //   setStatusIndex(steperror, current, updateField, 'error')
        //   return wizardError("Please select the employer experience.", name);
        // }
      } else if (wizard.employed_toggle === "0") {
        if (wizard.employed_retired_disabled === "Retired" && (wizard.employer_retire_from === "" || wizard.employer_retire_from === null)) {
          steperror = { ...steperror, employer_retire_from: true }
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Retire company name is required.", name);
        }
      }
    }

    if (wizard.business_owner_toggle === "1" || stepIndex === 10) {
      if (wizard.asset_401k_accounts_toggle === null) {
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Please select the retirement plan.", name);
      }
    }

    let asset_401k_accounts = [];
    if (
      wizard.asset_401k_accounts !== null &&
      !wizard.asset_401k_accounts.includes("None") &&
      wizard.asset_401k_accounts !== ""
    ) {
      asset_401k_accounts = JSON.parse(wizard.asset_401k_accounts);
    }

    if (wizard.asset_401k_accounts_toggle === 1) {
      if (asset_401k_accounts.length === 0) {
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Please select the type of the retirement plan.", name);
      } else {
        if (
          !asset_401k_accounts.includes("None") &&
          (wizard.asset_preservation_value === "" || wizard.asset_preservation_value === null)
        ) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please select the approximate value of the retirement plan.", name);
        } else {
          setStatusIndex(steperror, current, updateField, 'filled')
        }
      }
    } else {
      if (wizard.business_owner_toggle === "0" && wizard.asset_401k_accounts_toggle === null)
        setStatusIndex(steperror, current, updateField, 'error')
      else
        setStatusIndex(steperror, current, updateField, 'filled')
    }

    // if (wizard.spouse_first_name !== "" && wizard.spouse_last_name !== "") {
    //   if (wizard.business_owner_spouse_toggle === "1") {
    //     let asset_401k_accounts_spouse = [];
    //     if (
    //       wizard.asset_401k_accounts_spouse !== null &&
    //       wizard.asset_401k_accounts_spouse !== ""
    //     ) {
    //       asset_401k_accounts_spouse = JSON.parse(wizard.asset_401k_accounts_spouse);
    //     }
    //     if (wizard.asset_401k_accounts_toggle === "1") {
    //       if (asset_401k_accounts_spouse.length === 0) {
    //         setStatusIndex(steperror, current, updateField, 'error')
    //         return wizardError("Please select the type of the retirement plan.", name);
    //       } else {
    //         if (
    //           asset_401k_accounts_spouse.indexOf("None") < 0 &&
    //           wizard.asset_preservation_value_spouse === ""
    //         ) {
    //           setStatusIndex(steperror, current, updateField, 'error')
    //           return wizardError("Please select the approximate value of the retirement plan.", name);
    //         } else {
    //           setStatusIndex(steperror, current, updateField, 'filled')
    //         }
    //       }
    //     } else {
    //       setStatusIndex(steperror, current, updateField, 'filled')
    //     }
    //   }
    // }


    // if (stepIndex === 10) {
    //   let asset_401k_accounts = [];
    //   if (
    //     wizard.asset_401k_accounts !== null &&
    //     wizard.asset_401k_accounts !== ""
    //   ) {
    //     asset_401k_accounts = JSON.parse(wizard.asset_401k_accounts);
    //   }
    //   if (wizard.asset_401k_accounts_toggle) {
    //     if (asset_401k_accounts.length === 0) {
    //       setStatusIndex(steperror, current, updateField, 'error')
    //       return wizardError("Please select the retirement plan.", name);
    //     } else {
    //       if (
    //         asset_401k_accounts.indexOf("None") < 0 &&
    //         wizard.asset_preservation_value === ""
    //       ) {
    //         setStatusIndex(steperror, current, updateField, 'error')
    //         return wizardError(
    //           "Please select the approximate value of the retirement plan.", name
    //         );
    //       } else {
    //         setStatusIndex(steperror, current, updateField, 'filled')
    //       }
    //     }
    //   } else
    //     setStatusIndex(steperror, current, updateField, 'filled')
    // }

    // if (((wizard.business_owner_toggle || wizard.business_owner_spouse_toggle) && stepIndex === 9) || ((wizard.business_owner_toggle || wizard.business_owner_spouse_toggle) === "1" && stepIndex === 10)) {
    //   setStatusIndex(steperror, current, updateField, 'filled')
    // }
  }

  if (stepIndex >= 11 && stepIndex < 13) {
    if (stepIndex === 11) {
      let asset_accounts = []
      if (wizard.asset_accounts !== "" && wizard.asset_accounts !== null)
        asset_accounts = JSON.parse(wizard.asset_accounts)
      if (asset_accounts.length > 0 && asset_accounts.indexOf("None") < 0 && (wizard.asset_total_value === "" || wizard.asset_total_value === null)) {
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Household value is required.", name);
      }

      if (wizard.home_mortgage_protection_toggle === "" || wizard.home_mortgage_protection_toggle === null || wizard.life_insurance_toggle_3 === null) {
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Life insurance value is required.", name);
      }

      if (wizard.home_mortgage_protection_toggle === "1" && wizard.insurance_set === "financial") {
        let home_mortgage_protection_policy = [];
        if (wizard.home_mortgage_protection_policy && (wizard.home_mortgage_protection_policy !== "" || wizard.home_mortgage_protection_policy !== null)) {
          home_mortgage_protection_policy = JSON.parse(
            wizard.home_mortgage_protection_policy
          );
        }

        if (home_mortgage_protection_policy.length === 0) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Please select the life insurance.", name);
        }

        if (wizard.home_mortgage_protection_benefit === "" || wizard.home_mortgage_protection_benefit === null) {
          setStatusIndex(steperror, current, updateField, 'error')
          return wizardError("Benefit value of life insurance is required.", name);
        }
      }
    }

    if (stepIndex === 12) {
      if (wizard.employed_anual_income === "" || wizard.employed_anual_income === null) {
        setStatusIndex(steperror, current, updateField, 'error')
        return wizardError("Please fill all required fields.", name);
      } else {
        setStatusIndex(steperror, current, updateField, 'filled')
      }
    }
  }

  return true;
};

export default Validation;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/validation.js